import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v1/verify`;

export const verifyApi = {
  uploadLog: async (formData, onProgress) => {
    const res = await axios.post(`${API_BASE}/logs/uploads`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (evt) => {
        if (evt.total) onProgress(Math.round((evt.loaded / evt.total) * 100));
      },
    });
    return res.data;
  },

  getUpload: async (uploadId) => {
    const res = await axios.get(`${API_BASE}/logs/uploads/${uploadId}`);
    return res.data;
  },

  deleteUpload: async (uploadId) => {
    const res = await axios.delete(`${API_BASE}/logs/uploads/${uploadId}`);
    return res.data;
  },

  createJob: async (uploadId) => {
    const res = await axios.post(`${API_BASE}/logs/jobs`, { upload_id: uploadId });
    return res.data;
  },

  getJob: async (jobId) => {
    const res = await axios.get(`${API_BASE}/logs/jobs/${jobId}`);
    return res.data;
  },

  cancelJob: async (jobId) => {
    const res = await axios.post(`${API_BASE}/logs/jobs/${jobId}/cancel`);
    return res.data;
  },

  getReport: async (reportId) => {
    const res = await axios.get(`${API_BASE}/logs/reports/${reportId}`);
    return res.data;
  },

  getReportBots: async (reportId) => {
    const res = await axios.get(`${API_BASE}/logs/reports/${reportId}/bots`);
    return res.data;
  },

  getTimeseries: async (reportId, granularity = 'day') => {
    const res = await axios.get(`${API_BASE}/logs/reports/${reportId}/timeseries`, { params: { granularity } });
    return res.data;
  },

  exportReport: async (reportId) => {
    const res = await axios.get(`${API_BASE}/logs/reports/${reportId}/export`);
    return res.data;
  },

  deleteReport: async (reportId) => {
    const res = await axios.delete(`${API_BASE}/logs/reports/${reportId}`);
    return res.data;
  },

  getCatalog: async () => {
    const res = await axios.get(`${API_BASE}/bots/catalog`);
    return res.data;
  },
};
